import { StudentState, RecommendationRule } from "@/models/ActivityRollover";
import { RolloverRecommendationAction } from "@/features/planner/enums";

export function RolloverRecommendation(rules: RecommendationRule[]) {
  function match(state: StudentState): RecommendationRule | undefined {
    return rules.find((rule) => {
      const skillTypeMatch = !rule.skillType || rule.skillType === state.skillType;
      const startMatch = !rule.startMastery || rule.startMastery === state.startMastery;
      const endMatch = !rule.endMastery || rule.endMastery === state.endMastery;
      return skillTypeMatch && startMatch && endMatch;
    });
  }

  function get(state: StudentState): RolloverRecommendationAction | undefined {
    const rule = match(state);
    if (!rule) return undefined;
    return state.completedAssignments
      ? rule.recommendationCompleted
      : rule.recommendationIncomplete;
  }

  function explain(state: StudentState): {
    rule: RecommendationRule | undefined;
    action: RolloverRecommendationAction | undefined;
    reason: string;
  } {
    const rule = match(state);
    if (!rule) {
      return {
        rule: undefined,
        action: undefined,
        reason: "No matching rule found. The student state does not meet any known rule criteria.",
      };
    }

    const action = state.completedAssignments
      ? rule.recommendationCompleted
      : rule.recommendationIncomplete;

    const details = [
      `Matched rule: "${rule.scenario}"`,
      `Skill Type = ${state.skillType}`,
      `Mastery Start = ${state.startMastery}`,
      `Mastery Now = ${state.endMastery}`,
      `Completed = ${state.completedAssignments}`,
    ];

    return {
      rule,
      action,
      reason: details.join(" | "),
    };
  }

  function trace(state: StudentState) {
    if (process.env.NODE_ENV !== "development") return;

    const evaluations = rules.map((rule, i) => {
      const skillTypeMatch = !rule.skillType || rule.skillType === state.skillType;
      const startMatch = !rule.startMastery || rule.startMastery === state.startMastery;
      const endMatch = !rule.endMastery || rule.endMastery === state.endMastery;

      return {
        index: i,
        scenario: rule.scenario,
        matched: skillTypeMatch && startMatch && endMatch,
        skillTypeMatch,
        startMatch,
        endMatch,
      };
    });

    console.table(evaluations);
  }
  
  return { get, match, explain, trace };
}